import { ReactNode } from 'react';
import { lt } from '@mews/framework';
import { Tag, TagVariant } from '@optimus-web/core';

type RequirePaymentDuringOciTag = 'Required' | 'Hidden';

interface Props {
    status: RequirePaymentDuringOciTag;
}

const requirePaymentDuringOciTextKeyMap: Record<RequirePaymentDuringOciTag, { variant: TagVariant; label: ReactNode }> =
    {
        Required: {
            label: lt('Required'),
            variant: 'lavender',
        },
        Hidden: {
            label: lt('Hidden'),
            variant: 'denim',
        },
    };

export const RequirePaymentDuringOciCell = ({ status }: Props) => {
    const { label, variant } = requirePaymentDuringOciTextKeyMap[status];
    return <Tag variant={variant}>{label}</Tag>;
};
